import React from 'react';

import useLmsAdminCoursesDropdown from './UseLmsAdminCoursesDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LmsAdminCoursesDropdown = ({ label, name, value, error, message, onChange }) => {
  const { lmsAdminCoursesState } = useLmsAdminCoursesDropdown();

  return lmsAdminCoursesState.message
    ? <span className={global.LoadingMsg}>{lmsAdminCoursesState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={lmsAdminCoursesState?.options || []}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={lmsAdminCoursesState.isArrayLoading}
      />
    );
};

export default LmsAdminCoursesDropdown;